import { Observable, Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Breadcrumb } from '../../shared/domain/breadcrumb.entity';
import { IState } from '../../shared/store/root.reducer';
import { User } from '../../shared/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  breadcrumb$: Observable<Breadcrumb>;
  breadcrumbCssClass: string;
  currentUser: User;
  subscriptions: Subscription[] = [];

  constructor(
    private store: Store<IState>,
  ) { }

  ngOnInit() {
    this.breadcrumb$ = this.store.pipe(select(state => ({
      title: state.breadcrumb.title,
      subtitle: state.breadcrumb.subtitle,
      crumbs: state.breadcrumb.crumbs.filter((c, i) => i !== state.breadcrumb.crumbs.length - 1),
      // lastCrumb: state.breadcrumb.lastCrumb,
      cssIcon: state.breadcrumb.cssIcon,
    })));

    this.subscriptions.push(this.store.pipe(select(store => store.currentUser)).subscribe(currentUser => {
      if (currentUser) {
        this.currentUser = currentUser;
      }
    }));

    this.subscriptions.push(this.store.pipe(select(state => state.print))
      .subscribe(printState => {
        this.breadcrumbCssClass = printState.breadcrumbCssClass;
      }));
  }

  ngOnDestroy() {
    this.subscriptions.map(subscription => {
      subscription.unsubscribe();
    });
  }
}
